import { render, staticRenderFns } from "./ac-simple-wizard.vue?vue&type=template&id=774f1f54&"
import script from "./ac-simple-wizard.vue?vue&type=script&lang=js&"
export * from "./ac-simple-wizard.vue?vue&type=script&lang=js&"
import style0 from "./ac-simple-wizard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports